import { Middleware } from 'redux';

import { RootState } from '..';
import { ReduxDispatch } from '../actions/thunkActions';
import { isInteractiveEditActive, shouldInteractiveEditingBeDisabled } from '../selectors/interactiveEditingSelectors';
import { interactiveEditingSlice } from '../slices/interactiveEditingSlice';

function shouldInterruptEdit(previousState: RootState, newState: RootState): boolean {
  if (!shouldInteractiveEditingBeDisabled(previousState) && shouldInteractiveEditingBeDisabled(newState)) return true;
  if (previousState.layout.bearingEnvelopes !== newState.layout.bearingEnvelopes) return true;

  return false;
}

/**
 * Cancels an interactive edit if insertion begins, or other interrupting events occur while in progress.
 */
export const interactiveEditManagementMiddleware: Middleware<{}, RootState, ReduxDispatch> =
  (store) => (next) => (action) => {
    const previousState = store.getState();
    const result = next(action);

    const newState = store.getState();
    if (isInteractiveEditActive(newState) && shouldInterruptEdit(previousState, newState)) {
      store.dispatch(interactiveEditingSlice.actions.clearActiveEdit());
    }

    return result;
  };
